import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { forkJoin, Observable, throwError } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth/service/auth/auth.service';
import { CrossStorageService } from '../cross-storage/cross-storage.service';
// import { LayoutConfigService } from '../layout-config.service';

@Injectable({
	providedIn: 'root'
})
export class HttpclientService {

	serverUrl = "";

	constructor(
		private http: HttpClient,
		private appService: AppService,
		private authService: AuthService,
		private crossStorage: CrossStorageService,
	) { }

	public post(fragment: string, postData: string = null): Observable<any> {//need to add more params later for url, post data etc.
		let hkvp = {
			'Content-Type': 'application/json',
			'client': 'adminsure',
			'product': '',
			Authorization: `Bearer ${this.authService.getJwtToken()}`,
      		userid: '0x020000001DB809DF0B512C5D1EDC5E3BC8D2FC50E0CD9DD8BB14A102179A12A8B34676CB'
		};

		let headers = new HttpHeaders(hkvp);

		//console.log("HttpclientService.post>>>>>");

		return this.http.post(this.appService.getBaseUrl() + fragment, postData, { headers: headers, responseType: 'json' });//errors not handled atm
	}

	public get(fragment: string): Observable<any> {//need to add more params later for url, post data etc.
		let hkvp = {
			'Content-Type': 'application/json',
			'client': 'adminsure',
			'product': ''
		};

		let headers = new HttpHeaders(hkvp);

		//console.log("HttpclientService.post>>>>>");

		return this.http.get(this.appService.getBaseUrl() + fragment, { headers: headers, responseType: 'json' });//errors not handled atm
	}

	//not used atm
	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
			// A client-side or network error occurred. Handle it accordingly.
			console.error('An error occurred:', error.error.message);
		} else {
			// The backend returned an unsuccessful response code.
			// The response body may contain clues as to what went wrong.
			console.error(
				`Backend returned code ${error.status}, ` +
				`body was: ${error.error}`);
		}
		// Return an observable with a user-facing error message.
		return throwError(
			'Something bad happened; please try again later.');
	}

	public SaveData(data): any {
		let hkvp = {
			'Content-Type': 'application/json',
			'client': 'adminsure',
			'product': '',
			Authorization: `Bearer ${this.authService.getJwtToken()}`,
      		userid: '0x020000001DB809DF0B512C5D1EDC5E3BC8D2FC50E0CD9DD8BB14A102179A12A8B34676CB'
		};
		let options = { headers: hkvp };
		return this.http.post(`${this.serverUrl}/saveclaimcommunicationdetails `, data, options);
	}

	public mergeFieldAPI(payload) {
		let hkvp = {
			'Content-Type': 'application/json',
			'client': 'adminsure',
			'product': '',
			Authorization: `Bearer ${this.authService.getJwtToken()}`,
      		userid: '0x020000001DB809DF0B512C5D1EDC5E3BC8D2FC50E0CD9DD8BB14A102179A12A8B34676CB'
		};
		let options = { headers: hkvp };
		return this.http.post(`${this.serverUrl}/mergefields`, payload, options);
	}

	public getCommunicationinbosave(pageLoad) {
		let hkvp = {
			'Content-Type': 'application/json',
			'client': 'adminsure',
			'product': '',
			Authorization: `Bearer ${this.authService.getJwtToken()}`,
      		userid: '0x020000001DB809DF0B512C5D1EDC5E3BC8D2FC50E0CD9DD8BB14A102179A12A8B34676CB'
		};
		let options = { headers: hkvp };
		return this.http.post(`${this.serverUrl}/savedocumentmetadata `, pageLoad, options);
	}
	public getCommunicationinlettersave(pageLoad) {
		let hkvp = {
			'Content-Type': 'application/json',
			'client': 'adminsure',
			'product': '',
			Authorization: `Bearer ${this.authService.getJwtToken()}`,
      		userid: '0x020000001DB809DF0B512C5D1EDC5E3BC8D2FC50E0CD9DD8BB14A102179A12A8B34676CB'
		};
		let options = { headers: hkvp };
		return this.http.post(`${this.serverUrl}/saveorupdateletter `, pageLoad, options);
	}

	public getDocumentEditURL(dcn) {
		let hkvp = {
			'Content-Type': 'application/json',
			'client': 'adminsure',
			'product': '',
			Authorization: `Bearer ${this.authService.getJwtToken()}`,
      		userid: '0x020000001DB809DF0B512C5D1EDC5E3BC8D2FC50E0CD9DD8BB14A102179A12A8B34676CB'
		};
		let options = { headers: hkvp };
		return this.http.post(`${this.serverUrl}getdocumentmetadata`, { "dcn": `${dcn}`, options});
	}

	public combineData() {
		let response1 = this.getCommunicationMaster();
		// let response2 = this.getClaimCommunicationDetails(1111);

		return forkJoin([response1]);
	}

	public getCommunicationMaster() {
		let hkvp = {
			'Content-Type': 'application/json',
			'client': 'adminsure',
			'product': '',
			Authorization: `Bearer ${this.authService.getJwtToken()}`,
      		userid: '0x020000001DB809DF0B512C5D1EDC5E3BC8D2FC50E0CD9DD8BB14A102179A12A8B34676CB'
		};
		let options = { headers: hkvp };
		return this.http.post(`${this.serverUrl}/getcommunicationmaster`, {}, options);
	}

	public getlettertemplateemplayer() {
		let hkvp = {
			'Content-Type': 'application/json',
			'client': localStorage.getItem('client'),
			'product': '',
			Authorization: `Bearer ${this.authService.getJwtToken()}`,
      		userid: '0x020000001DB809DF0B512C5D1EDC5E3BC8D2FC50E0CD9DD8BB14A102179A12A8B34676CB'
		};
		let options = { headers: hkvp };
		let lobId = parseInt(sessionStorage.getItem("lobId"));
		return this.http.post(`${this.serverUrl}/getlettertemplateforemployer`, { "userId": "", "employerId": 0, "lobId": lobId }, options);

	}

	public postEmail(fragment: string, postData: string = null): Observable<any> {//need to add more params later for url, post data etc.
		let hkvp = {
			'Content-Type': 'application/json',
			'client': this.crossStorage.getSubdomain(),
			'product': '',
			'env': localStorage.getItem('env')
		};

		let headers=new HttpHeaders(hkvp);
		return this.http.post( fragment, postData,{headers:headers, responseType:'json'});//errors not handled atm
	}
}
